import { combineReducers } from 'redux';

import { ArticleAction, MediaViewerState } from '../types';
import { Reducer } from '../../../types';
import {
  setOpenMediaViewer,
  setCurrentIndexMediaViewer,
  setCurrentDocumentPageIndexMediaViewer,
} from '../actions';

type ReducerOf<T extends keyof MediaViewerState> = Reducer<MediaViewerState, ArticleAction, T>;

const open: ReducerOf<'open'> = (state = false, action) => {
  switch (action.type) {
    case setOpenMediaViewer.type:
      return action.payload;

    default:
      return state;
  }
};

const currentIndex: ReducerOf<'currentIndex'> = (state = 0, action) => {
  switch (action.type) {
    case setCurrentIndexMediaViewer.type:
      return action.payload;

    default:
      return state;
  }
};

const currentDocumentPageIndex: ReducerOf<'currentIndex'> = (state = 1, action) => {
  switch (action.type) {
    case setCurrentDocumentPageIndexMediaViewer.type:
      return action.payload;
    default:
      return state;
  }
};


export default combineReducers<MediaViewerState>({
  open,
  currentIndex,
  currentDocumentPageIndex,
});
